import { engageConstants } from "@constants";

export function listEngage(state = {}, action) {
    switch (action.type) {
        case engageConstants.ENGAGE_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case engageConstants.ENGAGE_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case engageConstants.ENGAGE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};